import { useState, useEffect, useContext } from "react";
import { Style } from "react-style-tag";
import lz from "lzutf8";
import { WebsiteContext } from "./WebsiteProvider";
import ProductDetails from "@/features/product-details/ProductDetails";
import OffersPopups from "@/components/OffersPopups";
import DrawerReader from "./components/DrawerReader";
import WebComponentReader from "./components/WebComponentReader";

const Website = () => {
  const [json, setJson] = useState();
  const { website, template } = useContext(WebsiteContext);

  useEffect(() => {
    if (website?.data || template?.data) {
      const json = lz.decompress(lz.decodeBase64(String(website?.data ?? template?.data ?? "")));
      setJson(json);
    }
  }, [website?.data, template?.data]);

  return (
    <>
      <WebComponentReader
        isLoading={!json}
        json={json ?? null}
      />
      <Style className="viewport" children={website?.styles ?? template?.styles ?? ""} />
      <ProductDetails />
      <OffersPopups />
      <DrawerReader/>
    </>
  );
};

export default Website;
